<template>
	<table class="table table-vcenter table-mobile-md card-table table-scroll">
		<thead>
			<tr class="d-sm-flex">
				<th class="col-sm-1"></th>
				<th class="col-sm-4">Họ tên</th>
				<th class="col-sm-3">Số điện thoại</th>
				<th class="col-sm-4">Địa chỉ</th>
			</tr>
		</thead>
		<tbody class="h-50" v-if="persons">
			<tr v-for="item in persons.data" class="d-sm-flex">
				<td data-label="" class="col-sm-1">
					<input class="form-check-input" type="checkbox" id="inlineCheckbox1" :value="item" v-model="list_check">
				</td>
				<td class="col-sm-4" data-label="Họ tên">{{item && item.person && item.person.name ? item.person.name : ''}}</td>
				<td class="col-sm-3" data-label="Số điện thoại">{{item && item.username ? item.username : ''}}</td>
				<td data-label="Địa chỉ" class="text-nowrap text-truncate col-sm-4">{{item && item.person && item.person.address ? item.person.address : ''}}</td>
			</tr>
      <tr v-if="persons && !persons.count">
        <td colspan="4" class="text-center">Không thấy bệnh nhân cần tìm kiếm</td>
      </tr>
		</tbody>
	</table>
</template>
<script>
export default {
  name: 'UserListInSendMess',
  props: ['persons', 'list_user'],
  data () {
    return {
      list_check: []
    }
  },
  watch: {
    'list_check': {
      handler: function () {
        let self = this
        self.$emit('sendListFormUserToDad', self.list_check)
      },
      deep: true
    },
    list_user: function () {
      let self = this
      self.list_check = self.list_user
    },
    deep: true
  },
  mounted () {
    this.list_check = this.list_user
  },
  methods: {
  }
}
</script>
<style scoped></style>